<template>
  <Modal :footer-hide="true" :mask-closable="false" v-model="show" :width="600">
    <div class="QHaccountEnter">
      <h1>立即登录</h1>
      <dl>
        <dt>登录账号</dt>
        <dd>
          <Input v-model="form.account" placeholder="请输入登录账号" maxlength="16" />
        </dd>
      </dl>
      <dl>
        <dt>登录密码</dt>
        <dd><Input v-model="form.password" type="password" placeholder="登录密码6-16位之间,必须含字母" maxlength="16" /></dd>
      </dl>
      <Button type="primary" class="QHbtnBig" @click="login()">立即登录</Button>
      <div class="formGroup flex-between" style="margin-top: 20px">
        <span></span>
        <div>
          <span class="QHset" @click="$emit('hello', 'QHzhuce')">注册账号</span>
          <span class="QHset" @click="$emit('hello', 'QHforget')">忘记密码</span>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import md5 from "js-md5";
import data from "./dataLogin.js";
export default {
  data() {
    return {
      list: [],
      show: false,
      form: { ...data.data },
    };
  },
  methods: {
    login() {
      var that = this;
      if (!that.$validAll(that.form, data.rule)) {
        return;
      }
      var parameter = { ...that.form };
      parameter.password = md5(parameter.password);
      that.$loading(true, "登录中...");
      that.$api.login(parameter).then((res) => {
        that.$loading(false);
        if (res.code == 0) {
          that.show = false;
          res.toolType = "QHlogin";
          that.$emit("success", res);
        } else {
          that.$msg(res.msg, "error");
        }
      });
    },
  },
};
</script>
<style>
.QHaccountEnter {
  margin: 20px;
}
.QHaccountEnter h1 {
  text-align: center;
  font-size: 24px;
  padding-bottom: 30px;
  font-weight: normal;
}
.QHaccountEnter dt {
  font-size: 15px;
  margin-bottom: 5px;
}
.QHaccountEnter dl {
  margin-bottom: 25px;
}
</style>
